import Link from "next/link";
import style from "./index.css";

export default () => {
  return (
    <>
      <section id="footer" className="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-xs-12">
              <div className="footer-brand">
              
            <img src="/static/img/1Gov/1Governemnt_Cloud_Logo.svg" 
                  alt=""
                />
                <div className="social">
                  <a href="#">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-facebook"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-youtube"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-8 col-xs-12">
              <div className="row">
                <div className="col-md-4 footer-cont">
                  <h3>Solutions</h3>
                  <ul>
                    <li>
                      <Link href="products/ecms">
                        <a>Gov ECMS</a>
                      </Link>
                    </li>
                    {/* <li>
                      <Link href="/products/customer-order-management">
                        <a>Customer Order Management</a>
                      </Link>
                    </li> */}
                    {/* <li>
                      <Link href="/products/inventory-management-system">
                        <a>Asset Management</a>
                      </Link>
                    </li> */}
                    <li>
                      <Link href="#">
                        <a>Asset Management</a>
                      </Link>
                    </li>
                    <li>
                      <Link href="/products/gov-drive">
                        <a>Gov Drive</a>
                      </Link>
                    </li>
                    <li>
                      <Link href="/products/gov-inmail">
                        <a>In Mail</a>
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="col-md-3 footer-cont">
                  <h3>Resources</h3>
                  <ul>
                    <li>
                      <a
                        href="https://galaxybackbone.com.ng/resources/"
                        target="_blank"
                      >
                        GBB Support
                      </a>
                    </li>
                    <li>
                    <Link href="/resources/policy-statement">
                        <a>Policy Statement</a>
                      </Link>
                    </li>

                    {/* <li>
                      <Link href="/resources/ebook">
                        <a>Ebook</a>
                      </Link>
                    </li>
                    <li>
                      <Link href="/affiliates">
                        <a>Affiliates</a>
                      </Link>
                    </li> */}
                  </ul>
                  
                </div>
                <div className="col-md-3 footer-cont">
                  <h3>Legal</h3>
                  <ul>
                    <li>
                      <Link href="https://galaxybackbone.com.ng/privacy/">
                        <a>Privacy Policy</a>
                      </Link>
                    </li>
                    <li>
                      <Link href="https://galaxybackbone.com.ng/data-protection-policy/">
                        <a>Terms of use</a>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="footer-btm">
        <div className="container">
          {/* <ul>
            <li>
              <Link href="/terms-of-service">
                <a>Privacy Policy</a>
              </Link>
            </li>
            <li>
              <Link href="/terms-of-service">
                <a>Terms of use</a>
              </Link>
            </li>
            <li>
              <a href="">Security</a>{" "}
            </li>
          </ul> */}
          <p className="">&copy; {new Date().getFullYear()} 1Government.</p>
        </div>
      </section>
      <style jsx>{style}</style>
    </>
  );
};
